/**
 * 页面按钮权限
 * @param code
 * */

import {Loading} from 'element-ui';
import {getButtonLimit} from "../api/permission";

export function getBtn(code,uniqueCode = '') {
  const options = {
    fullscreen: true,
    text: '加载中',
    target: document.getElementById('appMain') ?  document.getElementById('appMain') : 'body',
  }
  let loadingInstance = Loading.service(options);
    // let href = window.location.href;
    // let start = href.indexOf('=') + 1;
    // let end = href.indexOf('&') !== -1 ? href.indexOf('&') : href.length;
    // let index = href.substring(start, end);
   return getButtonLimit(JSON.stringify({uniqueCode})).then((res) => {
      loadingInstance && loadingInstance.close();
      if (res.data) {
        if ((code && res.data[code]) || !code) {
          return res.data;
        } else {
          location.href = '/errorPage';
        }
      } else {
        location.href = '/errorPage';
      }
    }).catch(() => {
      loadingInstance && loadingInstance.close();
    });
}

export const BTN_AUTH_KEY = 'pagePermissions'

/** 获取按钮权限集合缓存 */
export function getBtnAuth() {
  return JSON.parse(sessionStorage.getItem(BTN_AUTH_KEY))
}

/** 设置按钮权限集合缓存 */
export function setBtnAuth(data) {
  sessionStorage.setItem(BTN_AUTH_KEY, JSON.stringify(data))
}

/** 清除按钮权限集合缓存 */
export function clearBtnAuth() {
  sessionStorage.removeItem(BTN_AUTH_KEY)
}



// WEBPACK FOOTER //
// ./src/utils/btnAuth.js